import React from 'react';
import { 
    Drawer, 
    TextField, 
    IconButton,
    FormControlLabel,
    Checkbox,
    Tooltip,
    FormControl,
    InputLabel,
    Select,
    MenuItem
 } from '@material-ui/core/';
 
import RefreshIcon from '@material-ui/icons/Refresh';
import WarningIcon from '@material-ui/icons/Warning';
import ValidIcon from '@material-ui/icons/CheckCircle';

import EnhancedTable from "@apricityhealth/web-common-lib/components/EnhancedTable";
import { toBoolean } from '@apricityhealth/web-common-lib/utils/Utils';
import Plan from '@apricityhealth/web-common-lib/components/Plan';

import DetectModelView from './DetectModelView';
import EditableNote from '../components/EditableNote'
import PubSub from 'pubsub-js'

const MODEL_CATEGORIES = require('../data/ModelCategories.json');

function testFilter(filter, model) {
    if (model) {
        filter = filter.toLowerCase();
        if (model.name && model.name.toLowerCase().indexOf(filter) >= 0)
            return true;
        if (model.modelId && model.modelId.toLowerCase().indexOf(filter) >= 0)
            return true;
        if (model.description && model.description.toLowerCase().indexOf(filter) >= 0)
            return true;
    }
    return false;
}

export class DetectModelsView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            category: props.category || localStorage.getItem("DetectModelsView.category") || '',
            dependencies: JSON.parse(localStorage.getItem("DetectModelsView.dependencies") || 'true'),
            filter: '',
            types: [],
            conditionTypes: []
        }
    }

    componentDidMount() {
        this.token = PubSub.subscribe('STORE_UPDATE', this.loadContent.bind(this));
        this.loadContent();
    }

    componentDidUpdate(oldProps) {
        if ( oldProps.category !== this.props.category) {
            this.setState({ category: this.props.category}, this.loadContent.bind(this));
        } else {
            this.handleOpen();
        }
    }

    componentWillUnmount(){
        PubSub.unsubscribe(this.token);
    }

    loadContent() {
        const { appContext: { state: { plan }, stores: { DataTypesStore }}} = this.props;
        const { dependencies, category } = this.state;

        const types = DataTypesStore.getDetectModels().filter((k) => (dependencies || (plan && k.planId === plan.planId)) && (!category || k.category === category));
        const conditionTypes = DataTypesStore.getModels().filter((k) => dependencies || (plan && k.planId === plan.planId));
        this.setState({ types, conditionTypes }, this.onContentLoaded.bind(this));
    }
    
    onContentLoaded() {
        this.updateFilter();
        this.handleOpen();
    }

    handleOpen() {
        // automatically open the question by ID if provided..
        let parts = window.location.pathname.slice(1).split('/');
        if ( parts.length > 1) {
            window.history.replaceState( null, '',  window.location.href.substring( 0, window.location.href.lastIndexOf('/') ));
            this.onOpenModel( parts[1] );
        }
    }

    updateFilter() {
        let { types, filter } = this.state;
        if (filter) {
            var filtered = [];
            for (var i = 0; i < types.length; ++i) {
                if (testFilter(filter, types[i]))
                    filtered.push(types[i]);
            }
            this.setState({ filtered });
        }
        else {
            this.setState({ filtered: null });
        }
    }

    onCloseDialog() {
        this.setState({ dialog: null });
        this.loadContent();
        if (this._types)
            this._types.setState({ selected: [] });        // unselect the question
    }

    typeSelected(s, t) {
        console.log("typeSelected:", s, t);
        if (!t)
            throw new Error("t is null");
        if (s.length > 0) {
            const type = this.state.filtered ? this.state.filtered[s[0]] : this.state.types[s[0]];
            this.onOpenModel( type.modelId );
        }
        else {
            // nothing selected..
            this.setState({ dialog: null });
        }
    }

    onOpenModel(modelId) {
        const dialog = <Drawer variant="persistent" anchor="right" open={true}>
            <DetectModelView appContext={this.props.appContext} modelId={modelId} conditionTypes={this.state.conditionTypes}
                onClose={this.onCloseDialog.bind(this)} />
        </Drawer>;
        this.setState({ dialog });
    }

    createType() {
        console.log("createType");
        const { appContext } = this.props;
        const dialog = <Drawer variant="persistent" anchor="right" open={true} >
            <DetectModelView appContext={appContext} modelId='' category={this.state.category} onClose={this.onCloseDialog.bind(this)} />
        </Drawer>;
        this.setState({ dialog: dialog });
    }
    render() {
        const { appContext, appContext: { state: { plan: { planId } } } } = this.props;
        const { category, filtered, types, dialog, error, progress, dependencies } = this.state;
        const { filter } = this.state;
        const store = appContext.stores.DataTypesStore;
        const errors = store.getErrors(`detect_models`).errors;

        const columnData = [
            { id: 'modelId', width: 25, label: 'Valid', formatValue: (v) => {
                return errors[v] ? <Tooltip key='error' title={errors[v].join(', ')}><WarningIcon style={{ fill: 'red'}} /></Tooltip> : <ValidIcon key='valid' style={{ fill: 'green'}} />;
            }},
            { id: 'category', label: 'Category', formatValue: (v) => (MODEL_CATEGORIES.find((e) => e.value === v) || { label: v }).label  },
            { id: 'name', numeric: false, disabledPadding: false, label: 'Name' },
            { id: 'description', numeric: false, disabledPadding: false, label: 'Description' },
            { id: 'modelId', numeric: false, disabledPadding: false, label: 'Model ID' },
            { id: 'order', numeric: true, disabledPadding: false, label: 'Order' },
            { id: 'planId', numeric: false, disabledPadding: false, label: 'Plan ID', formatValue: (v) => {
                return <Plan appContext={this.props.appContext} planId={v} /> } },
            { id: 'inactive', label: 'Inactive', formatValue: (v) => toBoolean(v) ? "Yes" : "No" }
        ];

        return (
            <table width='100%'><tbody>
            <tr>
                <td>
                    <TextField style={{ margin: 5, width: 500 }} value={filter} label="Filter"
                        onChange={(e) => { this.setState({ filter }, this.updateFilter.bind(this)); }} />
                    <FormControl style={{ margin: 5, width: 300}}>
                        <InputLabel>Category</InputLabel>
                        <Select value={category} onChange={(e) => {
                            this.setState({ category: e.target.value }, this.loadContent.bind(this));
                            localStorage.setItem("DetectModelsView.category", `${e.target.value}`); 
                        }}>
                            <MenuItem value=''>All</MenuItem>
                            {MODEL_CATEGORIES.map((c) => <MenuItem key={c.value} value={c.value}>{c.label}</MenuItem>)}
                        </Select>
                    </FormControl>
                    <FormControlLabel style={{margin: 5}} control={<Checkbox checked={dependencies} onChange={(e) => { 
                        this.setState({dependencies: e.target.checked}, this.loadContent.bind(this )); 
                        localStorage.setItem("DetectModelsView.dependencies", `${e.target.checked}`); 
                        }} />} label="Show Dependencies" />
                </td>
                <td align="right">
                        {error}
                        <EditableNote appContext={appContext} textId={`detectModelsTooling`} planId={planId} />
                    <IconButton disabled={progress !== null} onClick={this.loadContent.bind(this)}>{progress || <RefreshIcon />}</IconButton>
                </td>
            </tr>
            <tr>
                <td colSpan="2">
                    <EnhancedTable
                        title=''
                        disableMultiSelect={true}
                        onTable={table => this._types = table}
                        onSelected={this.typeSelected.bind(this)}
                        onAdd={this.createType.bind(this)}
                        orderBy='name'
                        columnData={columnData}
                        data={filtered ? filtered : types} />
                    {dialog}
                </td>
            </tr>
            </tbody></table> 
        );
    }
}

export default DetectModelsView;
